import React, { FC } from "react";
import { FeatureDc } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { isGroupedFeature } from "../../../../evergis/core/feature/isGroupedFeature";
import { EditButtonsContainer } from "../../styled";
import { UngroupFeatureButton } from "./components/UngroupFeatureButton";
import { ControlsProps } from "./types";
import { ToggleGeometryModeButton } from "./components/ToggleGeometryModeButton";
import { GeometryEditorMode } from "../../../../ducks/geometryEditor/geometryEditor";

export const MultiPointControls: FC<ControlsProps> = ({ mode, feature }) => {
  const isGrouped = isGroupedFeature(feature as FeatureDc);
  const { t } = useTranslation("featureCard");

  return (
    <EditButtonsContainer>
      <ToggleGeometryModeButton
        mode={mode}
        selectMode={GeometryEditorMode.Edit}
        kind={"editgeom_point_vertex"}
        title={t("editVertices")}
      />
      <ToggleGeometryModeButton
        mode={mode}
        selectMode={GeometryEditorMode.Transform}
        kind={"geom_move"}
        title={t("move")}
      />
      <ToggleGeometryModeButton
        mode={mode}
        selectMode={GeometryEditorMode.Expand}
        kind={"editgeom_point_addpart"} // editgeom_point_ungroup
        title={t("addLine")}
      />
      {isGrouped && <UngroupFeatureButton kind={"geom_line_ungroup"} feature={feature} />}
    </EditButtonsContainer>
  );
};
